/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.operational-data-wireframe {
  @include mixins.page-grid-basics;
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  grid-template-rows: auto auto 1fr;
  grid-template-areas:
    'participants participants participants'
    'type location symptom-start'
    'type location destination';
}

.participants {
  grid-area: participants;
}

.start {
  grid-area: start;
}

.destination {
  grid-area: destination;
}

.location {
  grid-area: location;
}

.type {
  grid-area: type;
}

.symptom-start {
  grid-area: symptom-start;
}

.destination {
  grid-area: destination;
}
